import { USERS_TYPES } from '../../../../shared/constants';

export const ID_DOCUMENT_TYPE_IT = [
  { value: 'driving_licence', label: 'Patente di guida' },
  { value: 'passport', label: 'Passaporto' },
  { value: 'identity_document', label: 'Carta d’identita' },
  { value: 'residence_permit', label: 'Permesso di soggiorno' },
];

export const ID_DOCUMENT_TYPE_EN = [
  { value: 'driving_licence', label: 'Driving Licence' },
  { value: 'passport', label: 'Passport' },
  { value: 'identity_document', label: 'ID card' },
  { value: 'residence_permit', label: 'Residency permit' },
];

export const OCCUPATION_STUDENT = [
  USERS_TYPES.ITALIAN_STUDENT,
  USERS_TYPES.FOREIGN_STUDENT,
];
